import * as React from 'react'

import type { Field, Form } from 'factorial-form'

import { observer } from 'mobx-react'

import Select from 'modules/core/components/Inputs/Select'
import { useCallback } from 'modules/core/hooks/useCallback'
import hasFeature from 'modules/core/lib/hasFeature'
import i18n from 'modules/core/lib/i18n'
import LegalEntity from 'modules/core/store/models/LegalEntity'

import terminationTypesCollection from 'modules/payroll_bundle/store/collections/terminationTypes'
import type TerminationType from 'modules/payroll_bundle/store/models/TerminationType'

interface Props {
  form: Form
  country: string
}

const TerminationTypeList = ({ form, country }: Props) => {
  const terminationTypes = useCallback((country) => {
    let options = terminationTypesCollection.models
      .filter((one: TerminationType) => one.attributes.country === country)
      .map((type) => {
        return {
          label: type.attributes.description,
          value: type.attributes.id,
          termination_reason_type: type.attributes.termination_reason_type,
          slug: type.attributes.slug,
        }
      })
      .sort((a, b) => a.label.localeCompare(b.label))

    if (country === LegalEntity.countryDefaults.es) {
      const otrasIndex = options.findIndex((element) => element.slug === 'otras_causas')
      if (otrasIndex > -1) {
        const removed = options.splice(otrasIndex, 1)
        options = options.concat(removed)
      }
    }
    return options
  }, [])

  const options = terminationTypes(country)

  const onSelectChange = (field: Field) => {
    const selected = options.find((x) => x.value == field.value)?.termination_reason_type
    form.setValues({
      termination_reason_type: selected,
      termination_type_id: Number(field.value),
    })
    return field
  }

  return (
    <Select
      mandatory={hasFeature('payroll_bundle')}
      options={options}
      field={form.get('termination_type_id')}
      label={i18n.t('employees.termination.termination_reason')}
      none={i18n.t('employees.termination.termination_empty')}
      onChange={() => onSelectChange(form.get('termination_type_id'))}
    />
  )
}

export default observer(TerminationTypeList)
